import { Autocomplete, Box, Button, Paper, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import Subtitle from "../../../components/common/Subtitle";
import Title from "../../../components/common/Title";
import { getJsonAvailableYears } from "../../../services/gsuite/sheets";

/**
 * Component for the Client JSON section with internal handlers
 * @param {Object} props - Component props
 * @param {Array} props.companyNames - List of available company names
 * @param {Object} props.clientData - Current client data state
 * @param {Function} props.onChangeState - Handler for updating client data state
 * @param {Function} props.onSubmit - Handler for submit button click
 */
function Clients({ companyNames, clientData, onChangeState, onSubmit }) {
  const [availableYears, setAvailableYears] = useState([]);
  const quarters = ["Q1", "Q2", "Q3", "Q4", "ALL"];

  // Handler to update client data state in parent component
  const handleFieldChange = (field) => (e, value) => {
    onChangeState({ ...clientData, [field]: value });
  };

  const fetchAvailableYears = async () => {
    const availableYearsRes = await getJsonAvailableYears();
    const availableYearsJson = await availableYearsRes.json();
    availableYearsJson.available_years.push("ALL");
    setAvailableYears(availableYearsJson.available_years);
  };

  // Adding useEffect to fetch years when component mounts
  useEffect(() => {
    fetchAvailableYears();
  }, []);

  return (
    <Grid container direction="column" wrap="nowrap" spacing={4} p={{ xs: 2, md: 3 }} mx={{ xs: 0, md: "10%" }}>
      {/* Company Selection Section */}
      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Title text="Client JSON" sx={{ mb: 4, textAlign: "center" }} />

        <Box sx={{ mt: 3 }}>
          <Subtitle text="Company Selection" />
          <Autocomplete
            options={companyNames}
            renderInput={(params) => <TextField {...params} label="Select Company" />}
            onChange={handleFieldChange("company")}
            getOptionLabel={(option) => option}
            value={clientData.company}
            fullWidth
            size="medium"
          />
        </Box>

        <Box sx={{ mt: 3 }}>
          <Subtitle text="Year Selection" />
          <Autocomplete
            options={availableYears}
            renderInput={(params) => <TextField {...params} label="Year" />}
            onChange={handleFieldChange("year")}
            getOptionLabel={(option) => option}
            value={clientData.year}
            fullWidth
            size="medium"
          />
        </Box>

        <Box sx={{ mt: 3 }}>
          <Subtitle text="Quarter Selection" />
          <Autocomplete
            options={quarters}
            renderInput={(params) => <TextField {...params} label="Quarter" />}
            onChange={handleFieldChange("quarter")}
            getOptionLabel={(option) => option}
            value={clientData.quarter}
            fullWidth
            size="medium"
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Button variant="outlined" color="primary" size="large" onClick={onSubmit} sx={{ px: 4, py: 1 }}>
            Submit
          </Button>
        </Box>
      </Paper>
    </Grid>
  );
}

export default Clients;
